import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useLayoutEffect, useRef, useState } from 'react';

const CROSSFADE_MS = 150;

/** 手机顶栏左侧：替换 Logo 的当前页标题（切换时 crossfade） */
const MobileNavbarPageTitle = ({ pageTitle }) => {
	const prevTitleRef = useRef(pageTitle);
	const isFirstRenderRef = useRef(true);
	const timerRef = useRef(null);
	const [layers, setLayers] = useState({ current: pageTitle, previous: null });

	useLayoutEffect(() => {
		if (pageTitle === prevTitleRef.current) {
			return undefined;
		}

		if (isFirstRenderRef.current) {
			isFirstRenderRef.current = false;
			prevTitleRef.current = pageTitle;
			setLayers({ current: pageTitle, previous: null });
			return undefined;
		}

		setLayers({ current: pageTitle, previous: prevTitleRef.current });
		prevTitleRef.current = pageTitle;

		if (timerRef.current) {
			clearTimeout(timerRef.current);
		}
		timerRef.current = setTimeout(() => {
			setLayers((state) => ({ ...state, previous: null }));
			timerRef.current = null;
		}, CROSSFADE_MS);

		return () => {
			if (timerRef.current) {
				clearTimeout(timerRef.current);
				timerRef.current = null;
			}
		};
	}, [pageTitle]);

	return (
		<div className='navbar-top-page-title min-w-0'>
			{layers.previous ? (
				<p
					className='navbar-top-page-title__heading navbar-top-page-title__heading--exit mb-0 text-truncate'
					aria-hidden='true'
				>
					{layers.previous}
				</p>
			) : null}
			<p
				className={classNames('navbar-top-page-title__heading mb-0 text-truncate', {
					'navbar-top-page-title__heading--enter': Boolean(layers.previous),
				})}
				title={layers.current}
			>
				{layers.current}
			</p>
		</div>
	);
};

MobileNavbarPageTitle.propTypes = {
	pageTitle: PropTypes.string.isRequired,
};

export default MobileNavbarPageTitle;
